import { useTranslation } from 'next-i18next';

import { RangeInput } from './RangeInput';
import { NumericMenu } from './NumericMenu';

import styles from './PriceRefinement.module.scss';

const PriceRefinement = ({ attribute }: { attribute: string }) => {
  const { t } = useTranslation('searchResults');
  return (
    <div className={styles.priceRefinementRoot}>
      <NumericMenu
        attribute={attribute}
        items={[
          { label: t('numericMenu.1.all') },
          { label: t('numericMenu.2.under25'), start: 0, end: 25 },
          { label: t('numericMenu.3.25to50'), start: 25, end: 50 },
          { label: t('numericMenu.4.50to100'), start: 50, end: 100 },
          { label: t('numericMenu.5.100to200'), start: 100, end: 200 },
          { label: t('numericMenu.6.200to500'), start: 200, end: 500 },
          { label: t('numericMenu.7.500to1000'), start: 500, end: 1000 },
          { label: t('numericMenu.8.1000to2500'), start: 1000, end: 2500 },
          { label: t('numericMenu.9.2500&Up'), start: 2500 },
        ]}
      />
      <RangeInput attribute={attribute} />
    </div>
  );
};

export default PriceRefinement;
